import { render, staticRenderFns } from "./user-order-detail.vue?vue&type=template&id=6220ec48&scoped=true&"
import script from "./user-order-detail.vue?vue&type=script&lang=js&"
export * from "./user-order-detail.vue?vue&type=script&lang=js&"
import style0 from "./user-order-detail.vue?vue&type=style&index=0&id=6220ec48&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6220ec48",
  null
  
)

export default component.exports